import { Partner } from 'types';

export const getPartnerFromParticipant = (
  participant: any,
  partners: Partner[]
): Partner | undefined =>
  partners?.find((partner: Partner) => partner['_id'] === participant.member);
